import { useTranslation } from "react-i18next";
import { MAIN_SITE_URL } from "@/mocks/site";
import { heroBackgroundImage } from "@/mocks/categories";
import CategoryDropdown from "./CategoryDropdown";

export default function Hero() {
  const { t } = useTranslation();

  return (
    <section className="relative flex min-h-[92vh] w-full items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src={heroBackgroundImage}
          alt="AllChinaBuy spreadsheet product collage"
          className="h-full w-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/50"></div>
      </div>

      <div className="relative z-10 mx-auto w-full max-w-3xl px-4 py-24 text-center md:px-6">
        <span className="inline-flex items-center gap-2 rounded-full border border-white/30 bg-white/10 px-4 py-1.5 text-xs font-medium text-white backdrop-blur">
          <i className="ri-sparkling-2-line text-sm w-4 h-4 flex items-center justify-center"></i>
          {t("hero.badge")}
        </span>

        <h1 className="mt-6 text-3xl font-bold leading-tight text-white md:text-5xl">
          {t("hero.title")}
        </h1>

        <p className="mx-auto mt-5 max-w-2xl text-base leading-relaxed text-white/90 md:text-lg">
          {t("hero.subtitle")}
        </p>

        <div className="mt-8 flex flex-col items-center justify-center gap-3 sm:flex-row">
          <a
            href={MAIN_SITE_URL}
            target="_blank"
            rel="noopener nofollow"
            className="whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-semibold text-white transition-colors hover:bg-primary-600 cursor-pointer"
          >
            {t("hero.ctaExplore")}
          </a>
          <a
            href={MAIN_SITE_URL}
            target="_blank"
            rel="noopener nofollow"
            className="whitespace-nowrap rounded-md border border-white/40 bg-white/10 px-6 py-3 text-sm font-semibold text-white backdrop-blur transition-colors hover:bg-white/20 cursor-pointer"
          >
            {t("hero.ctaBuyNow")}
          </a>
        </div>

        <div className="mx-auto mt-8 w-full max-w-md">
          <CategoryDropdown />
        </div>
      </div>
    </section>
  );
}